import styled, { css } from 'styled-components';
import { StyledDropdownItem, StyledDropdownIcon } from './styledComponents';
import { Button, mainTheme } from '@plecto/ui';
import IconWithTooltip from '../../iconWithTooltip/IconWithTooltip';

export const MenuItem = styled(StyledDropdownItem)`
	align-items: stretch;
	${props => props.selected ? css`
		span,
		.icon {
			color: ${mainTheme.form.dropdown.menu.color};
		}
	` : ''}
	&:hover {
		.multi-level-dropdown-item-select {
			opacity: 1;
		}
	}
`;

export const ItemTitle = styled.span`
	flex: 1 0;
	align-items: start;
	padding: 6px 10px;
`;

export const ItemSubTitle = styled.span`
	color: ${mainTheme.text.tertiary};
	font-size: 12px;
`;

export const ItemCheckmark = styled(StyledDropdownIcon)`
	font-size: 12px;
	color: ${mainTheme.text.brand};
`;

export const ItemSelect = styled(Button)`
	transition: opacity 300ms;
	opacity: 0;
	border: none;
	background-color: transparent;
	color: ${mainTheme.text.primary};
	&:hover {
		background-color: transparent;
	}
`;

export const ItemMessage = styled(IconWithTooltip)`
	align-items: center;
	display: flex;
	color: ${mainTheme.text.tertiary};
	padding: 6px 10px;
`;
